import React, { useState, useEffect } from "react";
import storage from "../utils/storage";

const Footer = () => {
  const [source, setSource] = useState("");
  const [footerText, setFooterText] = useState("");

  const getSource = () => {
    const _source = storage.getItem("source");
    setSource(_source || "");

    if (_source === "formaxpay") {
      setFooterText("FORMAX IT SOLUTIONS PVT LTD");
    } else if (_source === "rechargepos") {
      setFooterText("FORMAX IT SOLUTIONS PVT LTD");
    } else if (_source === "api") {
      const _brandName = storage.getItem("brand_name");
      setFooterText(_brandName || "");
    }
  };

  useEffect(() => {
    getSource();
  }, []);

  return (
    <div className="custom-footer">
      <p>
        © {new Date().getFullYear()} {footerText}. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
